import { ActionTypes } from "./../actions/index";
import { NotificationState } from '../states';
import { NotificationActions } from "../actions/notification";

const getInitialState = (): NotificationState => {
    return {
        items: {}
    };
};

const notifications = (state = getInitialState(), action: ActionTypes): NotificationState => {
    switch (action.type) {
        case NotificationActions.SHOW:
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.payload.id]: action.payload
                }
            }
        case NotificationActions.DISMISS:
            return {
                ...state,
                items: Object
                    .keys(state.items)
                    .reduce((out, key) => (key === action.payload) ? out : { ...out, [key]: state.items[key] }, {})
            }
    }
    return state;
}

export default notifications;